/*
 * @Author: princemwang
 * @Date: 2022-06-22 15:05:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-01 16:37:13
 */
import GroupHeader from '@/components/header/groupHeader/Header';
import TmeHeader from '@/components/header/tmeHeader/Header';
import { IS_GROUP } from '@/utils';

const HeaderCom = () => {
  return <div id="header-layout">{IS_GROUP ? <GroupHeader /> : <TmeHeader />}</div>;
};
export default HeaderCom;
